export const points = [
  {
    id: 'f4b62099-293f-4c3d-a702-94eec4a2808c',
    basePrice: 1100,
    dateFrom: '2019-07-10T22:55:56.845Z',
    dateTo: '2019-07-11T11:22:13.375Z',
    destination: 'b4c3e4e6-9053-42ce-b747-e281314baa31',
    isFavorite: false,
    offers: [
      'b4c3e4e6-9053-42ce-b747-e281314baa31',
      'b4c3e4e6-9053-42ce-b747-e281314baa32',
    ],
    type: 'taxi'
  },
  {
    id: 'cfe416cq-10xa-3e10-8077-2fs9a01edcab',
    basePrice: 2100,
    dateFrom: '2019-07-10T22:55:56.845Z',
    dateTo: '2022-07-11T11:22:13.375Z',
    destination: 'bfa5cb75-a1fe-4b77-a83c-1e528e910e04',
    isFavorite: false,
    offers: [
      'b4c3e4e6-9053-42ce-b747-e281314baa40',
    ],
    type: 'bus'
  },
  {
    id: 'cfe416cq-10xa-ye21-8077-2fs9a01edcab',
    basePrice: 11000,
    dateFrom: '2019-07-10T22:55:56.845Z',
    dateTo: '2021-07-11T11:22:13.375Z',
    destination: 'bfa5cb75-a1fe-4b77-a84c-0e528e910e04',
    isFavorite: true,
    offers: [],
    type: 'sightseeing'
  }
];
